export default __webpack_public_path__ + "static/media/frontdesk-bill.8eae3f23.webp";